import Pages_RequestPageEditorPage from "@Pages/Pages/RequestPageEditorPage.vue";
import Pages_RequestPagesPage from "@Pages/Pages/RequestPagesPage.vue";
import Pages_RequestPageViewerPage from "@Pages/Pages/RequestPageViewerPage.vue";

export const routes = [
    {
        path: "/portfolio/pages/:workspaceId/:projectId",
        component: Pages_RequestPagesPage,
    },
    {
        path: "/decision/pages/:workspaceId/:projectId",
        component: Pages_RequestPagesPage,
    },

    {
        path: "/portfolio/edit-page/:workspaceId/:projectId/:pageId",
        component: Pages_RequestPageEditorPage,
    },
    {
        path: "/decision/edit-page/:workspaceId/:projectId/:pageId",
        component: Pages_RequestPageEditorPage,
    },

    {
        path: "/pageview/:accessKey",
        component: Pages_RequestPageViewerPage,
    },
]
